// The Auth0 identity-difference seam (SPEC-SOR-600-v4): the wire shapes the
// accounts reconciliation read and its Apply are described by, shared between
// the api-gateway that answers them and the surfaces that drive them — the
// portal's Setup → Accounts screen and the E2E fixtures that stub its routes.
//
// ONE DECLARATION PER SHAPE. The read's answer and the Apply's body are a
// contract between two apps, and a copy declared on each side is two chances to
// drift: the portal would render, or post, something the API never sends. These
// are declared once here and imported on both sides. The Apply's body is a Zod
// schema rather than a bare interface because it is also the validation shape
// the route parses its request with — the type is derived from it, so the
// documented contract and the accepted body can never be two declarations. The
// api-gateway's own read-side projection (`IdentityDifferenceRow`) and the
// planner's verdict (`IdentityApplyPlan`) are NOT here — neither one crosses the
// boundary.
import { z } from 'zod/v4';
/**
 * The parts of a member's offer a staff Apply named, by the value it named.
 * Each part is optional: an Apply carries the parts it confirmed, so a name
 * confirmed alone never carries the email and vice versa.
 *
 * This is the accepted body, not just a description of it — the route parses
 * its request with this schema, so a body the type admits is a body the route
 * takes, and `IdentityApplyRequest` below is derived from it rather than
 * declared beside it.
 */
export const IdentityApplyRequestSchema = z.object({
    email: z.string().optional(),
    names: z.object({ firstName: z.string(), lastName: z.string() }).optional(),
});
